import script from "./HiddenElement.vue?vue&type=script&lang=js"
export * from "./HiddenElement.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__